/**
 * Values grid — left-border style on navy bg (as on the reference home page).
 * Also works on off/white theme with adjusted colors.
 */
export default function ValuesList({ section }) {
  const { eyebrow, heading, cards = [], theme = "navy" } = section;
  const bgClass = theme === "navy" ? "bg-mist-navy text-white" : theme === "warm" ? "bg-mist-warm" : theme === "off" ? "bg-mist-off" : "bg-white";
  const headingColor = theme === "navy" ? "text-white" : "text-mist-navy";
  const itemTitle = theme === "navy" ? "text-white" : "text-mist-navy";
  const itemDesc = theme === "navy" ? "text-white/60" : "text-mist-ink/70";

  return (
    <section className={`relative ${bgClass} py-24 lg:py-32 overflow-hidden`}>
      <div className="container-mist relative">
        <div className="max-w-2xl text-left">
          {heading && (
            <h2 className={`font-display text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.1] tracking-tight ${headingColor}`}>
              {heading}
            </h2>
          )}
          {(eyebrow || heading) && <div className="mt-4 gold-divider" />}
        </div>
        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-8">
          {cards.map((c, i) => (
            <div key={i} className="py-1">
              <div className={`font-sans font-semibold text-lg tracking-tight ${itemTitle}`}>{c.title || c.description}</div>
              {c.title && c.description && c.description !== c.title && (
                <div className={`mt-2 text-xs ${itemDesc} leading-relaxed`}>{c.description}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
